/**
 * Copyright (c) 2025 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { datadogRum } from '@datadog/browser-rum';

class OnboardingPerformanceTracker {
  private stepStartTimes: Map<string, number> = new Map();

  /**
   * Call this when a step is shown to the user.
   */
  startStep(taskId: string): void {
    const startTime = Date.now();
    this.stepStartTimes.set(taskId, startTime);
  }

  /**
   * Call this when a step is completed (e.g., user submits the form).
   */
  completeStep(taskId: string, templateId: string, success: boolean): void {
    const startTime = this.stepStartTimes.get(taskId);
    if (!startTime) {
      // eslint-disable-next-line no-console
      console.warn(`No start time found for task ${taskId}`);
      return;
    }

    const duration = Date.now() - startTime;

    // Track slow steps (>30 seconds)
    if (duration > 30000) {
      datadogRum.addAction('onboarding_slow_step', {
        taskId,
        templateId,
        duration,
        success,
        timestamp: new Date().toISOString(),
      });
    }

    // Track very slow steps (>60 seconds)
    if (duration > 60000) {
      datadogRum.addAction('onboarding_very_slow_step', {
        taskId,
        templateId,
        duration,
        success,
        timestamp: new Date().toISOString(),
      });
    }

    datadogRum.addAction('onboarding_step_completed', {
      taskId,
      templateId,
      duration,
      success,
      timestamp: new Date().toISOString(),
    });

    this.stepStartTimes.delete(taskId);
  }
}

// Export singleton instance
export const onboardingPerformanceTracker = new OnboardingPerformanceTracker();
